import ArkOwlSocialMediaIcon from './ArkOwlSocialMediaIcon'

export default ArkOwlSocialMediaIcon
